import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';

import { App } from './App';
import './_i18n';
import { Loading } from './_components/Loading';
import { configureStore } from './_store';

const store = configureStore();

ReactDOM.render(
    <React.Suspense fallback={<Loading />}>
        <Provider store={store}>
            <App />
        </Provider>
    </React.Suspense>,
    document.getElementById('root')
);
